import React, { useEffect } from 'react';
import { Tab, TabGroup } from '@bloobirds-it/flamingo-ui';
import MessagingTabs from './messagingTabs';
import TasksTab from './tasksSection/tasksSection';
import { useContactView } from '../../../hooks';
import ActivitySection from '../../../components/activitySection';
import styles from './contactTabs.module.css';
import { ScheduleEmailModal } from '@bloobirds-it/email';
import ConfirmSendAutomatedEmailModal from '../../../components/confirmSendAutomatedEmailModal/confirmSendAutomatedEmailModal';
import useSendAutomatedEmail from '../../../hooks/useSendAutomatedEmail';
import useRescheduleAutomatedEmail from '../../../hooks/useRescheduleAutomatedEmail';
import CancelEmailModal from '../../../components/cancelEmailModal/cancelEmailModal';
import useCancelEmail from '../../../hooks/useCancelEmail';

const ContactTabs = () => {
  const { tab, setTab, resetTab } = useContactView();
  const {
    isOpen: isOpenScheduledModal,
    closeRescheduleAutomatedEmailModal,
    rescheduleEmail,
  } = useRescheduleAutomatedEmail();
  const { isOpen: isOpenConfirmSendEmail } = useSendAutomatedEmail();
  const { isOpen: isOpenCancelEmailModal, closeCancelEmailModal } = useCancelEmail();

  useEffect(
    () => () => {
      resetTab();
    },
    [],
  );

  return (
    <div
      id="contact-tabs"
      className={styles._container}
      data-intercom="activity-messaging-task-tabs"
    >
      <TabGroup value={tab} onClick={setTab}>
        <Tab dataTest="activityContactTab" name="Activity" iconLeft="activity">
          <ActivitySection />
        </Tab>
        <Tab dataTest="messagingContactTab" name="Messaging" iconLeft="file">
          <MessagingTabs />
        </Tab>
        <Tab dataTest="taskContactTab" name="Tasks" iconLeft="calendar">
          <TasksTab />
        </Tab>
      </TabGroup>
      {isOpenScheduledModal && (
        <ScheduleEmailModal
          emails={[]}
          onClose={closeRescheduleAutomatedEmailModal}
          onSubmit={async ({ date }) => {
            closeRescheduleAutomatedEmailModal();
            rescheduleEmail({ datetime: date });
          }}
        />
      )}
      {isOpenCancelEmailModal && <CancelEmailModal handleClose={closeCancelEmailModal} open />}
      {isOpenConfirmSendEmail && <ConfirmSendAutomatedEmailModal />}
    </div>
  );
};

export default ContactTabs;
